import { render, staticRenderFns } from "./starplan.vue?vue&type=template&id=8b0df890&scoped=true&"
import script from "./starplan.vue?vue&type=script&lang=js&"
export * from "./starplan.vue?vue&type=script&lang=js&"
import style0 from "./starplan.vue?vue&type=style&index=0&id=8b0df890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0df890",
  null
  
)

export default component.exports